export default "__VITE_ASSET__B9yx39uN__"